export enum HousingSituation {
    Residence = 'Residence',
    RentedProperty = 'RentedProperty',
    WithOtherBorrower = 'WithOtherBorrower'
}
